module.exports = __webpack_public_path__ + "img/ninja-newspaper.5aebcb1a.svg";